import React from 'react';

import BonusPageEdit from '../BonusPage/BonusPageEdit';
import { API_CASINO_DEPOSIT_BONUS_PAGES } from '../Helpers/CrmApiUrls';
import { CASINO_DEPOSIT_BONUS_PAGES } from '../Helpers/CrmUrls';

function DepositBonusPageEdit() {
    return <BonusPageEdit apiUrl={API_CASINO_DEPOSIT_BONUS_PAGES} returnUrl={CASINO_DEPOSIT_BONUS_PAGES} />;
}

export default DepositBonusPageEdit;
